
import { Vue, Component, Prop } from "vue-property-decorator";
import VisitErrorNotification, { ErrorNotificationData } from "./VisitErrorNotification.vue";

@Component({
  components: {
    VisitErrorNotification,
  },
})
export default class VisitErrorNotificationContainer extends Vue {
  @Prop({ type: Array, default: () => [] }) readonly errors!: ErrorNotificationData[];
  @Prop({ type: Boolean, default: true }) readonly show!: boolean;

  get shouldShowErrors(): boolean {
    return this.show;
  }

  get hasErrors(): boolean {
    return this.errors.length > 0 && this.errors.some(error => error.show);
  }

  get visibleErrors(): ErrorNotificationData[] {
    return this.errors.filter(error => 
      error.show && 
      !['skills', 'soft_skills', 'travel'].includes(error.type)
    );
  }

  get skillsError(): ErrorNotificationData | null {
    return this.errors.find(error => error.type === 'skills' && error.show) || null;
  }

  get softSkillsError(): ErrorNotificationData | null {
    return this.errors.find(error => error.type === 'soft_skills' && error.show) || null;
  }

  get travelError(): ErrorNotificationData | null {
    return this.errors.find(error => error.type === 'travel' && error.show) || null;
  }

  getTransportIcon(type: string): string {
    const iconMap: Record<string, string> = {
      'car': 'CarIcon',
      'bus': 'BusIcon', 
      'walk': 'PersonStandingIcon',
      'bike': 'BikeIcon',
    };
    return iconMap[type] || 'CarIcon';
  }
}
